import { GridColumn, IIdentity } from '.';

export interface DialogContext<T extends IIdentity> {
  column: GridColumn<T>;
  data: T;
  allowEditing?: boolean;
  additionalData?: any;
}
